export default __webpack_public_path__ + "static/media/maropost-logo.6732ad53.svg";